<template>
    <div>
        <k-cell-group v-if="info">
            <k-cell title="订单详情" />
            <k-cell size="small" title="订单号"     :value="info.orderno" />
            <k-cell size="small" title="创建时间"   :value="info.createtime*1000|formatDate" />
            <k-cell size="small" title="订单状态"   :value="statusText" />
            <k-cell size="small" title="订单金额">
                <span class="k-price">{{info.money|fen2yuan}}</span>
            </k-cell>
            <k-cell size="small" title="已付款">
                <span class="k-price">{{info.money|fen2yuan}}</span>
            </k-cell>
            <k-cell v-if="info.paytime" size="small" title="支付时间"   :value="info.paytime*1000|formatDate" />
        </k-cell-group>
    </div>

</template>

<script>
    import {mapGetters} from "vuex"
    export default {
        name: "order-info",
        props : ["info"],
        computed : {
            ...mapGetters("jianding", ["getOrderDetail","CONST"]),
            statusText(){
                return this.CONST.ORDER_STATUS_TEXT[this.info.status||""]
            }
        },
        watch: {
            info(nv){
                console.log(nv)
            }
        }
    }
</script>

<style scoped>

</style>